import React, { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { subscribe } from "../../lib/api";

export default function SubscribeForm({
  source = "community",
  testIdPrefix = "subscribe",
  compact = false,
}) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Enter a valid email to be heard.");
      return;
    }
    setLoading(true);
    try {
      const res = await subscribe(email, source);
      if (res.already_subscribed) {
        toast("You're already on the scrolls.", {
          description: "We will summon you when the pilot arrives.",
        });
      } else {
        toast.success("Welcome to the dream.", {
          description: "Watch your inbox for the first chapter.",
        });
      }
      setEmail("");
    } catch (err) {
      toast.error("The candle flickered. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      className={`flex w-full gap-2 ${compact ? "flex-row" : "flex-col sm:flex-row"}`}
      data-testid={`${testIdPrefix}-form`}
    >
      <Input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@inbox.realm"
        className="bg-[#0A0A0A] border border-white/10 rounded-none h-12 text-[#EAE0D5] placeholder:text-[#737373] focus-visible:ring-[#C5A059] focus-visible:ring-1 focus-visible:ring-offset-0"
        data-testid={`${testIdPrefix}-email-input`}
      />
      <Button
        type="submit"
        disabled={loading}
        className="bg-[#C5A059] text-black rounded-none h-12 px-6 hover:bg-[#D4AF68] tracking-[0.18em] uppercase text-xs font-medium shrink-0"
        data-testid={`${testIdPrefix}-submit`}
      >
        {loading ? "Summoning…" : "Subscribe"}
      </Button>
    </form>
  );
}
